import React, { ReactNode } from 'react';

import classNames from 'classnames';

import classes from './FormFieldsGrid.module.scss';
import { Mode } from '../../../../general-types';

type FormFieldsGridProps = {
  children: ReactNode;
  className?: string;
  customPadding?: boolean;
  mode?: Mode;
};

/**
 * Grid container with 3 columns paddings and a bottom border
 * Use it to wrap your form fields in a challenge create form
 *
 * Depend on mode change padding and gap
 */
export const FormFieldsGrid = ({
  children,
  className,
  customPadding = false,
  mode,
}: FormFieldsGridProps) => {
  return (
    <div
      className={classNames(classes.container, className, {
        [classes.padding]: !customPadding,
        [classes.viewMode]: mode === 'VIEW',
      })}
    >
      {children}
    </div>
  );
};
